import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteDashboardViewRPC } from "./deleteDashboardViewRPC";

export class DeleteDashboardViewRPCClientImpl extends DeleteDashboardViewRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteDashboardViewRPC.Request): Promise<LeoRPCResult<DeleteDashboardViewRPC.Response, DeleteDashboardViewRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/DeleteDashboardView",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteDashboardViewRPC.ResponseDTO,
      DeleteDashboardViewRPC.Errors.ErrorsDTO,
      DeleteDashboardViewRPC.Response,
      DeleteDashboardViewRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/DeleteDashboardView",
      DeleteDashboardViewRPC.Response.fromDTO,
      DeleteDashboardViewRPC.Errors.fromDTO
    );
  }
}
